/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lead_Open_ClientInputs */

const cs_lead_open_client = /** @type {(inputs: Lead_Open_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevřít klienta`)
};

const en_lead_open_client = /** @type {(inputs: Lead_Open_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open client`)
};

/**
* | output |
* | --- |
* | "Open client" |
*
* @param {Lead_Open_ClientInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lead_open_client = /** @type {((inputs?: Lead_Open_ClientInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lead_Open_ClientInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lead_open_client(inputs)
	return cs_lead_open_client(inputs)
});